import{defineMessages}from"react-intl";export default defineMessages({ariaLabel:{id:"neptune.ClearButton.ariaLabel"}});